import React, { useState } from 'react'
import './NotificationBanner.css'

type NotificationBannerProps = {
  children?: React.ReactNode
  style?: React.CSSProperties
  onClose?: () => void
}

const NotificationBanner = ({ children, style, onClose }: NotificationBannerProps) => {
  const [isVisible, setIsVisible] = useState(true)

  const handleClose = () => {
    setIsVisible(false)

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  if (!isVisible) {
    return null
  }

  return (
    <div className="NotificationBanner" style={style}>
      <div>{children}</div>
      <button
        type="button"
        className="NotificationBannerClose"
        aria-label="Close"
        onClick={handleClose}>
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  )
}

export default NotificationBanner
